import { supabase, isConfigured } from './supabase';
import type { Activity, ActivityType } from '../types';

export interface CreateActivityInput {
  team_id: string;
  contact_id?: string | null;
  deal_id?: string | null;
  owner_user_id?: string | null;
  type: ActivityType;
  body: string;
  happened_at?: string;
}

export async function getActivities(teamId: string, limit = 50): Promise<Activity[]> {
  if (!isConfigured) return [];

  const { data, error } = await supabase
    .from('sales_activities')
    .select('*')
    .eq('team_id', teamId)
    .order('happened_at', { ascending: false })
    .limit(limit);

  if (error) {
    console.error('[activities] fetch failed:', error);
    return [];
  }

  return data as Activity[];
}

export async function getActivitiesForDeal(dealId: string): Promise<Activity[]> {
  if (!isConfigured) return [];

  const { data, error } = await supabase
    .from('sales_activities')
    .select('*')
    .eq('deal_id', dealId)
    .order('happened_at', { ascending: false });

  if (error) {
    console.error('[activities] fetch for deal failed:', error);
    return [];
  }

  return data as Activity[];
}

export async function getActivitiesForContact(contactId: string): Promise<Activity[]> {
  if (!isConfigured) return [];

  const { data, error } = await supabase
    .from('sales_activities')
    .select('*')
    .eq('contact_id', contactId)
    .order('happened_at', { ascending: false });

  if (error) {
    console.error('[activities] fetch for contact failed:', error);
    return [];
  }

  return data as Activity[];
}

export async function createActivity(input: CreateActivityInput): Promise<Activity | null> {
  if (!isConfigured) return null;

  const { data, error } = await supabase
    .from('sales_activities')
    .insert({
      ...input,
      happened_at: input.happened_at || new Date().toISOString(),
    })
    .select()
    .single();

  if (error) {
    console.error('[activities] create failed:', error);
    return null;
  }

  return data as Activity;
}

export async function deleteActivity(id: string): Promise<boolean> {
  if (!isConfigured) return false;

  const { error } = await supabase
    .from('sales_activities')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('[activities] delete failed:', error);
    return false;
  }

  return true;
}
